import React from "react";
import { Link } from "react-router-dom";

export default function EmployeesPublicSuccess() {
  return (
    <section className="py-5">
      <div className="container" style={{ maxWidth: 680, textAlign: "center" }}>
        <div className="card shadow-sm">
          <div className="card-body p-5">
            <h3 className="mb-3">Thanks for registering!</h3>
            <p className="text-muted">
              Your application has been submitted and is{" "}
              <strong>pending</strong> review. We’ll reach out on your
              mobile/email if we need more details.
            </p>
            <Link to="/" className="btn btn-primary mt-3">
              Go to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
